import HighchartsReact from "highcharts-react-official";
import Highcharts, { color } from "highcharts";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import moment from "moment";

const LyingPosition = ({ data, startTime, endTime }) => {
  const { t } = useTranslation();

  const [chartData, setChartData] = useState({
    faceUp: [],
    faceDown: [],
    time: []
  });

  const toLocalTime = (utcTime, day) => {
    var date = new Date(utcTime + "+00:00");
    let hour = date.getHours();
    if (hour < 15) {
      day = 0;
    }
    date.setDate(date.getDate() - day);
    return (new Date(date)).getTime() - ((new Date(date)).getTimezoneOffset() * 60 * 1000)
  }

  useEffect(() => {

    const faceUp = data.filter((item) => item.type === 'SLEEP_FACE_UP').map((item) => ({
      x: item.dateTime,
      y: item.value,
      z: 999,
      type: 'SLEEP_FACE_UP'
    }));

    console.log("faceUp", faceUp)

    const faceDown = data.filter((item) => item.type === 'SLEEP_FACE_DOWN').map((item) => ({
      x: item.dateTime,
      y: item.value,
      z: 999,
      type: 'SLEEP_FACE_DOWN'
    }));
    console.log("faceDown", faceDown)

    setChartData({
      faceUp,
      faceDown,
    });
  }, [data]);

  const options = {
    title: {
      text: "",
    },
    chart: {
      type: "scatter",
      height: 250,
      marginLeft: 100,
      marginTop: 0,
      marginBottom: 0,
    },
    xAxis: {
      type: "datetime",
      tickWidth: 0,
      tickInterval: 30 * 60 * 1000, // 30 minutes in milliseconds
      gridLineWidth: 2,
      gridLineDashStyle: "dot",
      lineColor: "black",
      lineWidth: 5,
      labels: {
        enabled: false
      },
      min: startTime, // 6:30 PM today
      max: endTime, // 9:30 AM tomorrow
      margin: 10,
    },
    yAxis: {
      title: {
        text: `<div><span style="display: block;">${t("graph.tempePosi.rightFacing")}</span> </br> <span style="display: block; margin-top: 78px">${t("graph.tempePosi.leftFacing")}</span></div>`,
        rotation: 0,
        useHTML: true,
        style: {
          fontSize: 16,
          color: "#000000",
          fontWeight: "bold",
        },
        x: 72,
        y: -60
      },
      labels: {
        enabled: false,
      },
      min: -255,
      max: 255,
      lineColor: "black",
      lineWidth: 2,
    },
    series: [
      {
        name: t("graph.tempePosi.faceUp"),
        data: chartData.faceUp,
        marker: {
          symbol: "circle",
          radius: 5,
          fillColor: "#7ED957",
        },
        zIndex: 2,
      },
      {
        name: t("graph.tempePosi.faceDown"),
        data: chartData.faceDown,
        marker: {
          symbol: "circle",
          radius: 5,
          fillColor: "#CF69CF",
        },
        zIndex: 3,
      },
      {
        name: "Line",
        type: "line",
        color: "#0cc0df",
        data: [
          { x: startTime, y: 0 },
          { x: endTime, y: 0 },
        ],
        enableMouseTracking: false,
        zIndex: 1,
      },
    ],
    tooltip: {
      formatter: function () {
        console.log(this);
        const x = this.x;
        const formattedX = moment(new Date(x)).utc().format("HH:mm:ss");
        const y = this.y;
        const title = this.point.options.type === 'SLEEP_FACE_UP' ? `${t("graph.tempePosi.faceUp")}` : `${t("graph.tempePosi.faceDown")}`


        return `<text x="8" data-z-index="1" y="18" style="color: rgb(51, 51, 51);fill: rgb(51, 51, 51);padding-bottom: 3px;"><tspan style="color: rgb(44, 175, 254); fill: rgb(44, 175, 254);">●</tspan> <tspan> ${title}</tspan><tspan class="highcharts-br" dy="15" x="8">​</tspan>${t("graph.tempePosi.time")}: <tspan style="font-weight: bold;">${formattedX}</tspan><tspan class="highcharts-br" dy="15" x="8">​</tspan>${t("graph.tempePosi.value")}: <tspan style="font-weight: bold;">${y}</tspan><tspan class="highcharts-br">​</tspan></text>`;
      }
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
        },
      },
      line: {
        marker: {
          enabled: false,
        },
      },
    },
  };
  const chartRef = useRef();

  useEffect(() => {
    console.log(
      "chartRef --- ",
      chartRef?.current?.chart?.series[0].series,
      Highcharts
    );
    if (chartRef?.current?.chart?.series?.[0]?.data?.[0]) {
    }
  }, []);
  return (
    <div className="chart-lying-position">
      <HighchartsReact
        ref={chartRef}
        highcharts={Highcharts}
        options={options}
      />
    </div>
  );
};

export default LyingPosition;
